import { useEffect, useState } from 'react';
import { useTheme } from '../App';
import './Navbar.css';

const SECTIONS = ['about', 'skills', 'experience', 'projects', 'contact'];

export default function Navbar() {
  const { dark, setDark } = useTheme();
  const [active, setActive] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const ratios = new Map(SECTIONS.map((id) => [id, 0]));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          ratios.set(e.target.id, e.isIntersecting ? e.intersectionRatio : 0);
        });
        let topId = null;
        let topRatio = 0;
        ratios.forEach((r, id) => {
          if (r > topRatio) { topRatio = r; topId = id; }
        });
        setActive(topRatio > 0 ? topId : null);
      },
      { rootMargin: '-40% 0px -55% 0px', threshold: [0, 0.25, 0.5, 0.75, 1] }
    );
    SECTIONS.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-logo">VR</div>

      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
        {SECTIONS.map(s => (
          <li key={s}>
            <button
              className={`nav-link ${active === s ? 'active' : ''}`}
              onClick={() => scrollTo(s)}
            >
              {s}
            </button>
          </li>
        ))}
      </ul>

      <div className="nav-controls">
        <button className="theme-btn" onClick={() => setDark(!dark)}>
          <i className={`ti ${dark ? 'ti-sun' : 'ti-moon'}`} />
          <span>{dark ? 'Light' : 'Dark'}</span>
        </button>
        <button
          className="nav-burger"
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Toggle menu"
        >
          <i className={`ti ${menuOpen ? 'ti-x' : 'ti-menu-2'}`} />
        </button>
      </div>
    </nav>
  );
}
